module.exports = __webpack_public_path__ + "img/logo.efa5f910.png";